import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { ViewportScroller } from '@angular/common';

@Component({
  selector: 'app-tap-to-top',
  templateUrl: './tap-to-top.component.html',
  styleUrls: ['./tap-to-top.component.scss']
})
export class TapToTopComponent implements OnInit, OnDestroy {

  public show: boolean = false;
  private scrollListener!: () => void;

  constructor(
    private viewScroller: ViewportScroller,
    private ngZone: NgZone,
  ) {}

  ngOnInit(): void {
    this.ngZone.runOutsideAngular(() => {
      this.scrollListener = (): void => {
        const number = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        const next = number > 600;
        if (next !== this.show) {
          this.ngZone.run(() => { this.show = next; });
        }
      };
      window.addEventListener('scroll', this.scrollListener, { passive: true });
    });
  }

  ngOnDestroy(): void {
    window.removeEventListener('scroll', this.scrollListener);
  }

  tapToTop() {
  	this.viewScroller.scrollToPosition([0, 0]);
  }

}
